import { useState } from 'react';
import { TSectionSelected } from './Components/RoundResultsSectionSelector/RoundResultsSectionSelector';

type TUseResultsSectionSelector = () => [
  TSectionSelected,
  (section: TSectionSelected) => () => void
];

export const useResultsSectionSelector: TUseResultsSectionSelector = () => {
  const [sectionSelected, setSectionSelected] = useState<TSectionSelected>('Scorecards');
  const onSetSection = (section: TSectionSelected) => () => setSectionSelected(section);

  return [sectionSelected, onSetSection];
};
